module.exports = "/images/vendor/multiselect/switch.png?a74d0364e70eccc2f1a75345a43eb11d";